import { createSvgIcon } from "@mui/material";

export const AlignLeftIcon = createSvgIcon(
  <svg viewBox="0 0 15 9" fill="none">
    <path
      fill="currentColor"
      d="M.633 0c.369 0 .633.29.633.633v2.953h12.636a.633.633 0 1 1 0 1.266H1.266v2.953a.61.61 0 0 1-.633.633A.625.625 0 0 1 0 7.805V.633C0 .29.29 0 .633 0"
    />
  </svg>,
  "AlignLeftIcon",
);
